module.exports = __webpack_public_path__ + "static/media/identification-selected.6f88b047.svg";